<template>
  <NotMobile__WP_Alert />
  <ColoredBG type="default"/>
  <div class="editor-container d-flex justify-center mt-5">
    <v-card v-if="isCreating" :color="`#f6f6f6`" flat rounded="xl">
      <template v-slot:title>
        Создаю отчёт
      </template>
      <template v-slot:text>
        <p>Подготавливаем отчётные данные</p>
      </template>
    </v-card>

    <v-card v-if="report_data && !isCreating" :color="`#f6f6f6`" flat rounded="xl">
      <template v-slot:title>
        Данные успешно получены!
      </template>
    </v-card>

    <v-card v-if="!report_data && !isCreating" :color="`#f6f6f6`" flat rounded="xl">
      <template v-slot:title>
        <div class="d-flex">
          <span class="font-weight-bold">Создать отчёт по договору</span>
        </div>
      </template>
      <template v-slot:subtitle  v-if="!range || !contract">
        Для создания отчёта, необходимо выбрать
        <span v-if="!contract" class="font-weight-bold">ДОГОВОР</span>
        <span v-if="!range && !contract"><br>и </span>
        <span v-if="!range">
          отчётный <span class="font-weight-bold">ПЕРИОД</span>, <br v-if="!range && contract">за который вы хотите сформировать отчёт
        </span>
      </template>
      <template v-slot:append>
        <div class="d-flex">
          <BrowserSaver v-if="!report_data && !isCreating" />
        </div>
      </template>
      <template v-slot:text>
        {{ selected_cal }}
        <v-autocomplete
            density="compact"
            flat
            hide-details
            variant="solo"
            style="min-width: 300px"
            label="Договор"
            item-title="label"
            item-value="value"
            :items="contracts"
            v-model="contract"
            class="my-2"
        >
          <template v-slot:clear>
            <v-icon :icon="['fas', 'xmark']" v-on:click="clearContract()" />
          </template>
        </v-autocomplete>

        <grdn-calendar v-model="range" range />
      </template>
      <template v-slot:actions>
        <v-btn block rounded="xl" v-if="range && contract" v-on:click="getReportData()" variant="flat" color="light-green">
          <template v-slot:default>
            СФОРМИРОВАТЬ ОТЧЕТ
          </template>
        </v-btn>
        <v-btn v-else block rounded="xl" variant="plain" color="deep-orange" disabled>
          <template v-slot:default>
            НЕВОЗМОЖНО СФОРМИРОВАТЬ ОТЧЕТ
          </template>
        </v-btn>
      </template>
    </v-card>
  </div>
</template>

<script>
import { Rep_Contract, Rep_Contracts, Rep_Period, Rep_Step, Rep_Steps } from "@/store/report/SmallStorrage";
import { ReportData } from "@/store/report/ReportData";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import randomstring from "randomstring";
import ColoredBG from "@/components/Style/ColoredBG.vue";
import { BakedData } from "@/store/report/BakedData";
import BrowserSaver from "@/components/Reports/BrowserSaver.vue";
import moment from "moment";
import {AppsStore} from "@/store/AppsList";
import route_check from "@/libs/route_check";
import NotMobile__WP_Alert from "@/components/wp_planner/alerts/not_mobile.alert.vue";
import { Allerts } from "@/store/global/Allerts";
import GrdnCalendar from "@/components/grdn/grdn-calendar.vue";
import {UUID} from "@/libs/magic";


export default {
  name: "reportCreate",
  components: {GrdnCalendar, NotMobile__WP_Alert, BrowserSaver, ColoredBG },
  async beforeMount() {
    route_check('/report/create').then(async res => {
      if (res) {
        this.createNew()
        this.local_file = null
        await this.getContractList()
      } else {
        this.$router.push({ name: 'home' })
      }
    })
  },
  data() {
    return {
      selected_cal: null,
      calendar: {
        rules: [
          {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          },
          {
            hours: 23,
            minutes: 59,
            seconds: 59,
            milliseconds: 999,
          }
        ]
      },
      isCreating: false,
      selected_btn: null,
      drawer: false
    }
  },
  methods: {
    isSelected: function (range) {
      let start, end = null
      switch (range) {
        case 'm_current':
          start = moment().startOf('month')
          end = moment().endOf('month')
          break;
        case 'm_prev':
          start = moment().subtract(1, 'month').startOf('month')
          end = moment().subtract(1, 'month').endOf('month')
          break;
        case 'q_1':
          start = moment().month(0).startOf('month')
          end = moment().month(0).add(2, 'month').endOf('month')
          break;
        case 'q_2':
          start = moment().month(3).startOf('month')
          end = moment().month(3).add(2, 'month').endOf('month')
          break;
        case 'q_3':
          start = moment().month(6).startOf('month')
          end = moment().month(6).add(2, 'month').endOf('month')
          break;
        case 'q_4':
          start = moment().month(9).startOf('month')
          end = moment().month(9).add(2, 'month').endOf('month')
          break;
        case 'hy_1':
          start = moment().month(0).startOf('month')
          end = moment().month(5).endOf('month')
          break;
        case 'hy_2':
          start = moment().month(6).startOf('month')
          end = moment().month(11).endOf('month')
          break;
        case 'year-now':
          start = moment().startOf('year')
          end = moment().endOf('day')
          break;
        case 'year-prev':
          start = moment().subtract(1, 'years').startOf('year')
          end = moment().subtract(1, 'years').endOf('year')
      }
      start = start.format("YYYY-MM-DD[T]HH:mm:ss")
      end = end.format("YYYY-MM-DD[T]HH:mm:ss")

      return this.range && this.range.start === start && this.range.end === end
    },

    createNew: function () {
      this.report_data = null
      this.clearContract()
    },
    clearDate: function () {
      this.range = null
      this.selected_cal = null
      this.selected_btn = null
    },
    clearContract: function () {
      this.contract = null
      this.clearDate()
    },
    recalculateSpace: function () {
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.reports.forEach((report) => {
            group.availableSpace = this.$rep_cfg.charts.find(el => el.guid === report.report_guid)
            if (group.availableSpace) {
              group.availableSpace = 3 - group.availableSpace.needSpace
            } else {
              group.availableSpace = 0
            }
          })
        })
      })
    },
    recalculatePages: function () {
      let page = 1
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.page = page
          page++
        })
      })
    },

    getReportData: function () {
      this.isCreating = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetReport`
      let raw = JSON.stringify(this.preparedData)

      let requestOptions = {
        method: 'POST',
        body: raw,
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      }

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(async result => {
            /*for (let [index, element] of result.data.entries()) {
              element['id'] = 'r_'+index
              element['uuid'] = uuidv4()
            }*/
            result['unused'] = []
            result['groups'] = []
            result['section_list'] = []

            for (let element of result.data) {
              if (!(result['section_list']).find(elem => elem['name'] === element['report_group'])) {
                result['section_list'].push({
                  name: element['report_group'],
                  guid: UUID(),
                  /*uuid: element['unique_guid'],
                  //uuid: element['uuid'],
                  type: 'chart',*/
                  groups: this.getGroups(this.getReposrts((result.data).filter(rep => rep['report_group'] === element['report_group'])))
                })
              }
            }
            result['range'] = this.range
            this.report_data = result
            this.recalculateSpace()
            this.recalculatePages()

            this.$router.push({ name: 'report__editor'})
          })
          .catch(error => {
            console.error(error)
            Allerts().warn('ОШИБКА', `Ошибка в формировании отчёта: ${error}`, '#f00', 'alert')
            this.createNew()
          }).finally(() => {
            this.isCreating = false
          })
    },
    getReposrts: function (reports) {
      for (let report of reports) {
        report.description_note = this.generateDescription(report)
      }
      return reports
    },
    generateDescription: function (report) {
      let description = null
      if (report.report_guid === 'dc768591-0d39-11eb-8114-00155d01060e') {
        description = 'Выявленные неисправности:'
        report.report_data.map(el => {
          switch (el['Тип']) {
            case 'КоличествоНеиспраностей':
              if (el['Ссылка']) {
                description += ` \n${el['СсылкаНомер']}: ${el['Описание']}`
              }
              break;
          }
        })
      }
      return description
    },
    getGroups: function (reports) {
      let groups = []
      for (let [index, report] of reports.entries()) {
        groups.push({
          guid: randomstring.generate(16),
          name: 'group_'+index,
          /*page: this.pages,*/
          type: "group",
          reports: [report]
        })
        /*this.pages++*/
      }
      return groups
    },
    getContractList: async function () {
      this.contracts = []
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetObjects`

      let requestOptions = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        }
      };

      await fetch(url, requestOptions)
          .then(response => response.text())
          .then(async result => {
            let contracts = []
            for (let object of await JSON.parse(result)) {
              contracts.push({
                label: object['ДоговорПредставление'],
                value: object['ObjectGUID']
              })
            }
            contracts.sort((a, b) => a.label.localeCompare(b.label))
            this.contracts = contracts
          })
          .catch(error => {
            console.error(error)
          })
    }
  },
  computed: {
    preparedData() {
      return {
        ObjectGUID: this.contract,
        dateStart: this.range.start,
        dateEnd: this.range.end
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    },
    steps: {
      get() {
        return Rep_Steps().get()
      },
      set(value) {
        Rep_Steps().set(value)
      }
    },
    contracts: {
      get() {
        return Rep_Contracts().get()
      },
      set(value) {
        Rep_Contracts().set(value)
      }
    },
    range: {
      get() {
        return Rep_Period().get()
      },
      set(value) {
        Rep_Period().set(value)
      }
    },
    contract: {
      get() {
        return Rep_Contract().get()
      },
      set(value) {
        Rep_Contract().set(value)
      }
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    },
    backed_data: {
      get() {
        return BakedData().get()
      },
      set(value) {
        BakedData().set(value)
      }
    },
    apps: {
      get() {
        return AppsStore().get()
      },
      set(value) {
        AppsStore().set(value)
      }
    },
    step: {
      get() {
        return Rep_Step().get()
      },
      set(value) {
        Rep_Step().set(value)
      }
    },
    list() {
      let list = []
      for (let [index, step] of this.steps.entries()) {
        list.push({
          title: `Шаг ${index+1}`,
          content: step.name,
          icon: (step.status ? 'wi-check-circle' : 'wi-cross-circle')
        })
      }
      return list
    }
  }
}
</script>
